import React from 'react';
import styled from 'styled-components';

import { ProfileCardRow } from '@modules/profile/moleculas';
import { ProfileCard } from '@modules/profile/organisms';

import type { StudentProfileSectionEntity } from '@modules/students/entities';

type StudentProfileProps = {
    sections: StudentProfileSectionEntity[];
};

const Root = styled.div`
    width: 100%;
    max-width: 620px;
`;

const StudentProfile = (props: StudentProfileProps): React.ReactElement => {
    const { sections } = props;

    return (
        <Root>
            {sections.map((section, index) => (
                <ProfileCard key={index} title={section.name}>
                    {section.items.map(item => (
                        <ProfileCardRow key={item.label} label={item.label}>
                            {item.getFieldOrDefaultValue('value')}
                        </ProfileCardRow>
                    ))}
                </ProfileCard>
            ))}
        </Root>
    );
};

export { StudentProfile };
